module.exports = __webpack_public_path__ + "img/hot_tag.02444ef4.png";